import Slider from "react-slick";
import JourneyCircle from "./JourneyCircle";

const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    swipeToSlide: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
            },
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                initialSlide: 2,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
};

const CircleSlider = () => (
    <Slider {...settings}>
        <JourneyCircle
            color="#00858F"
            date={{ mese: "September", anno: "2022" }}
            title="Company"
            subtitle="foundation"
        />
        <JourneyCircle
            color="#383456"
            date={{ mese: "November", anno: "2022" }}
            title="First product"
            subtitle="at TRL 5"
        />
        <JourneyCircle
            color="#3E2950"
            date={{ mese: "January", anno: "2023" }}
            title="Pre-seed"
            subtitle="investment"
        />
        <JourneyCircle
            color="#353572"
            date={{ mese: "August", anno: "2023" }}
            title="First commercial"
            subtitle="customer"
        />
        <JourneyCircle
            color="#03466E"
            date={{ mese: "February", anno: "2024" }}
            title="Seed investment"
            subtitle=""
        />
        <JourneyCircle
            color="#03466E"
            date={{ mese: "April", anno: "2024" }}
            title="First space-qualified"
            subtitle="product"
        />
        <JourneyCircle
            color="#44968b"
            date={{ mese: "September", anno: "2024" }}
            title="First flight hardware delivered"
            subtitle="to a commercial customer"
        />
        <JourneyCircle
            color="#367558"
            date={{ mese: "December", anno: "2024" }}
            title="First flight hardware"
            subtitle="integrated for launch"
        />
        <JourneyCircle
            color="#a657ad"
            date={{ mese: "MARCH", anno: "2025" }}
            title="[SARA](/products/sara) & [HOLLY](/products/holly)"
            subtitle="in orbit"
        />
        <JourneyCircle
            color="#ad5788"
            date={{ mese: "August", anno: "2025" }}
            title="First US customer"
            subtitle=""
        />
        <JourneyCircle
            color="#b8476a"
            date={{ mese: "November", anno: "2025" }}
            title="MARA SADA"
            subtitle="product release"
        />
        <JourneyCircle
            color="#c2394e"
            date={{ mese: "November", anno: "2025" }}
            title="PAVEL "
            subtitle="in orbit"
        />
        <JourneyCircle
            color="#c93040"
            date={{ mese: "May", anno: "2026" }}
            title="[SARA Pro](/products/sara)  "
            subtitle="sold to the first customer"
        />
    </Slider>
);

export default CircleSlider;